import { render, staticRenderFns } from "./sendGeneralWhats.vue?vue&type=template&id=45319e21"
import script from "./sendGeneralWhats.vue?vue&type=script&lang=js"
export * from "./sendGeneralWhats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports